<template>
  <v-card
    outlined
    class="px-6 pt-6 pb-3"
  >
    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
      <label class="subtitle-1 d-block grey--text">Publish Status</label>
    </div>

    <v-select
      outlined
      v-model="publishStatusListener"
      :items="statusOptions"
    />

  </v-card>
</template>
<script>

export default {
  props: {
    publishStatus: {
      type: String,
      default: 'draft'
    }
  },
  data () {
    return {
      statusOptions: [
        {
          text: 'Draft',
          value: 'draft'
        },
        {
          text: 'Published',
          value: 'published'
        },
        {
          text: 'Unpublished',
          value: 'unpublished'
        }
      ]
    }
  },
  computed: {
    publishStatusListener: {
      get () {
        return this.publishStatus
      },
      set (val) {
        this.$emit('update:publishStatus', val)
      }
    }
  }
}
</script>
